import { render, staticRenderFns } from "./price-card.vue?vue&type=template&id=c3fc00f6&scoped=true&"
import script from "./price-card.vue?vue&type=script&lang=js&"
export * from "./price-card.vue?vue&type=script&lang=js&"
import style0 from "./price-card.vue?vue&type=style&index=0&id=c3fc00f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3fc00f6",
  null
  
)

export default component.exports